module.exports = __webpack_public_path__ + "static/wlbg01-84d778ca86071f98df233720d6bd8737.jpg";